<template>
  <a-spin :spinning="loading">
    <div class="app-container">
      <div id="feishu-user-profile" />
    </div>
  </a-spin>
</template>
<script>
import { setCookies } from '@/utils/utils';
import { getSignature } from '@/api/system/auth';

export default {
  props: {
    openId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      error: false,
      myComponent: null,
      config: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.authSignature();
    });
  },
  deactivated() {
    this.myComponent.unmount();
  },
  methods: {
    authSignature(retry = true) {
      getSignature({ url: window.location.href })
        .then(response => {
          this.error = false;
          this.loading = false;
          this.config = {
            openId: response.data.openId, // 当前登录用户的open id，要确保与生成signature使用的user_access_token相对应
            signature: response.data.signature, // 签名
            appId: response.data.appId, // 应用 appId
            timestamp: response.data.timestamp, // 时间戳（毫秒）
            nonceStr: response.data.nonceStr, // 随机字符串
            url: response.data.url, // app URL
            jsApiList: ['user_profile'], // 使用成员名片组件时取值为 ['user_profile']
            locale: 'zh-CN'
          };
          if (retry === true) {
            this.loadComponents();
          }
        })
        .catch(() => {
          this.error = true;
          this.loading = false;
        });
    },
    loadComponents() {
      const that = this;
      window.webComponent.config({ ...this.config }).then(res => {
        that.myComponent = window.webComponent.render(
          'UserProfile',
          {
            openId: that.openId // 要展示哪个用户的成员名片
          },
          document.querySelector('#feishu-user-profile') // 将组件挂在到哪个元素上
        );
      });
      // 捕获组件内部错误
      window.webComponent.onError(function (error) {
        console.error('custom error:', error);
      });
      // 捕获 sdk 鉴权错误
      window.webComponent.onAuthError(function (error) {
        console.error('auth error callback', error);
        that.authSignature(false);
      });
    },
    onReLogin() {
      localStorage.removeItem('token');
      localStorage.removeItem('user_info');
      localStorage.removeItem('refreshToken');
      setCookies('token'); // 清除token
      setCookies('refreshToken'); // 清除refreshToken
      window.location.href = process.env.VUE_APP_SSO_URL + '?url=' + window.location.href;
    }
  }
};
</script>

<style lang="less" scoped>
.app-container {
  width: 224px;
  height: 364px;
}
#feishu-user-profile {
  border-radius: 12px;
  transform: scale(0.7);
  transform-origin: top left;
}
</style>
